import { ExpertAnketaDescription } from './ExpertAnketaDescription';

export default ExpertAnketaDescription;